import { getCountryIso, type LocaleIso } from 'utils';
import {
  ADDRESS_COUNTRY_CODE_ALIASES,
  COUNTRIES_WITH_GLOBAL_ADDRESS_SELECTION,
  LOCALES_REQUIRING_COUNTRY_MATCH
} from '../constants';

function hasGlobalAddressSelection(country: string): boolean {
  return COUNTRIES_WITH_GLOBAL_ADDRESS_SELECTION.includes(
    country as (typeof COUNTRIES_WITH_GLOBAL_ADDRESS_SELECTION)[number]
  );
}

/** Returns whether a saved country is supported by the current locale. */
export function isAddressCountrySupportedForLocale(countryCode: string | undefined, locale: LocaleIso): boolean {
  if (!countryCode) {
    return false;
  }

  const normalizedCountry = countryCode.toUpperCase();
  const country =
    ADDRESS_COUNTRY_CODE_ALIASES[normalizedCountry as keyof typeof ADDRESS_COUNTRY_CODE_ALIASES] ?? normalizedCountry;
  const localeCountry = getCountryIso(locale).toUpperCase();

  if (LOCALES_REQUIRING_COUNTRY_MATCH.includes(locale)) {
    return country === localeCountry;
  }

  return hasGlobalAddressSelection(localeCountry) || !hasGlobalAddressSelection(country);
}
